import React, { useEffect, useContext } from 'react';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import Layout from '../../components/Layout/Layout';
import { AppType } from '../../store/store';

import css from './ApproverDeclined.module.scss';

interface Props {
  app: AppType;
}

const ApproverDeclined = (props: Props) => {
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.trackEvent('Registration Error Triggered', {
      eventProps: {
        registration_step: 'confirm_code',
        error_message:
          'It looks like you’ve been invited to join an account. Use the link sent to your phone number to join. Didn’t get a text? Call (888) 483–2645.'
      }
    });
  }, []);

  return (
    <Layout>
      <div className={css.ApproverDeclinedMainBox}>
        <h1 data-e2e="verify-declined-header">
          Let&apos;s get you linked to your family&apos;s account
        </h1>
        <p>
          It looks like you’ve been invited to join an account. Use the link
          sent to your phone number to join.
        </p>
        <p>
          Didn’t get a text? Call{' '}
          <a href="tel:888-483-2645" data-e2e="telephone-number">
            (888) 483–2645
          </a>
          .
        </p>
      </div>
    </Layout>
  );
};

export default ApproverDeclined;
